import React from 'react';
import { connect } from 'react-redux';
import { getSetsIdsByModel } from './../../../../../../store/reducers/sets';
import Row from './item';
import BreadCrumbs  from './breadcrumbs';

const Sets = props => {
  const { sets, setsIdsByModel} = props;
  return (
    <div>
      <BreadCrumbs />
      <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
        {setsIdsByModel.map(key => <Row set={sets[key]} key={key} setId={key} />)}
      </div>
    </div>
  );
}

export default connect(
  state => ({
    sets: state.sets,
    setsIdsByModel: getSetsIdsByModel(state.sets, state.ui.model),
  })
)(Sets);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/list/list.js